import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { NotificationViewDto } from "./getUserNotifications";

export type NotificationsViewReturn = IAxiosReturn<NotificationViewDto[]>;

export interface NotificationQueryParams {
  notificationId: number;
}

/**
 * Updates all notifications as viewed.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param _ - Unused parameter for consistency with loader signature
 * @param controller - Optional AbortController for cancelling the request
 * @returns Promise<NotificationsViewReturn>
 */
export const updateAllNotificationsAsViewed = async (
  backEndUrl: string,
  _: string,
  controller?: AbortController,
): Promise<NotificationsViewReturn> => {
  // Send data
  try {
    const url = `${backEndUrl}Comments/MarkAllNotificationsAsViewed`;
    const response: { data: NotificationViewDto[] } = await axios.put(
      url,
      controller ? { signal: controller.signal } : undefined,
    );
    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("update notifications status failed", error);
  }
};
